import React from 'react';
import { Facebook, Figma, Chrome } from 'lucide-react';
import { Certification } from '../types';

const About: React.FC = () => {
  const certifications: Certification[] = [
    {
      icon: <Facebook className="w-5 h-5 text-text-light" />,
      title: "Social Media Management",
      provider: "Meta",
      date: "Feb 2024"
    },
    {
      icon: <Figma className="w-5 h-5 text-text-light" />,
      title: "Get Started with Figma",
      provider: "Coursera",
      date: "Mar 2024"
    },
    {
      icon: <Chrome className="w-5 h-5 text-text-light" />,
      title: "Foundations of User Experience Design",
      provider: "Google",
      date: "Dec 2022"
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-16">
          <div className="md:w-1/2 lg:w-5/12">
            <img
              src="/assets/profile.png"
              alt="Sveva Falanga"
              className="rounded-2xl shadow-xl w-full object-cover"
            />
          </div>
          <div className="md:w-1/2 lg:w-7/12">
            <h2 className="text-4xl font-semibold mb-6">About Me</h2>
            <p className="text-lg text-slate-600 mb-4 leading-relaxed">
              I am a Social Media Expert with a background in Sociology from
              the University of Naples Federico II. My academic work,
              including a Social Network Analysis on COVID-19's impact, gives
              me a unique, analytical perspective on digital communities.
            </p>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              My experience spans content moderation, sales, and dedicated
              language studies, all of which contribute to my holistic
              approach to communication and user engagement.
            </p>
            <div className="border-t border-gray-200 pt-8">
              <h3 className="text-2xl font-semibold mb-5">Certifications</h3>
              <ul className="space-y-4">
                {certifications.map((cert, index) => (
                  <li key={index} className="flex items-start gap-3">
                    {cert.icon}
                    <div>
                      <h4 className="font-semibold">{cert.title}</h4>
                      <p className="text-sm text-slate-500">{cert.provider}, {cert.date}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 